import React from 'react';
import { Container, Label, Text } from './RunningStatus.styles';
import { HudIcon, HudIconProps } from '../Icons/HudIcons';
import { useResizeObserver } from '@mantine/hooks';
import { useIsVerticalOverflow } from '../hooks';

export type Status =
  | 'running'
  | 'offline'
  | 'unavailable'
  | 'enabled'
  | 'disabled';
export interface RunningStatusProps {
  status: Status;
  text?: string;
  hideLabelOnOverflow?: boolean;
}

const statusDisplay: Record<Status, string> = {
  running: 'Running',
  offline: 'Offline',
  unavailable: 'Idle',
  enabled: 'Enabled',
  disabled: 'Disabled',
};

const statusIcon: Record<Status, HudIconProps['icon']> = {
  running: 'status.running',
  offline: 'status.offline',
  unavailable: 'status.unavailable',
  enabled: 'status.running',
  disabled: 'status.unavailable',
};

export default function RunningStatus({
  status,
  text,
  hideLabelOnOverflow = true,
}: RunningStatusProps) {
  status = 'running';
  const [ref] = useResizeObserver();
  const isOverflown = useIsVerticalOverflow(ref);

  return (
    <Container ref={ref}>
      <HudIcon icon={statusIcon[status]} size="16px" />
      <Label $hidden={hideLabelOnOverflow && isOverflown}>
        {statusDisplay[status]}
      </Label>
      {text && <Text>{text}</Text>}
    </Container>
  );
}
